import { useContext } from "react";
import { useQuery } from "react-query";
import { apiAxios } from "services/HttpServices";
import { LoginStateContext } from "context/Login/LoginState";

async function fetchJobs(_, searchQuery) {
  try {
    if (searchQuery) {
      const res = await apiAxios.get(`/jobs?filter[name][like]=${searchQuery}`);
      return res.data;
    } else {
      const res = await apiAxios.get(`/jobs`);
      return res.data;
    }
  } catch (e) {
    console.log(e);
  }
}

async function fetchJobsWithPagination(_, { pageIndex, pageSize }) {
  try {
    const res = await apiAxios.get(
      `/jobs?page[size]=${pageSize}&page[number]=${pageIndex}`
    );
    return res.data;
  } catch (e) {
    console.log(e);
  }
}

function useJobData({ searchQuery, pagePagination }) {
  const { user: userState } = useContext(LoginStateContext);

  if (searchQuery) {
    return useQuery(["jobs", searchQuery], fetchJobs, {
      enabled: userState.isLoggedIn && searchQuery,
    });
  }
  if (pagePagination) {
    const { pageIndex, pageSize } = pagePagination;
    return useQuery(
      ["jobs", { pageIndex, pageSize }],
      fetchJobsWithPagination,
      {
        enabled: userState.isLoggedIn && pageIndex,
      }
    );
  }
  return useQuery(["jobs"], fetchJobs, {
    enabled: userState.isLoggedIn,
  });
}

export default useJobData;
